import { useState } from "react";

//import material
import {
  Grid,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Card,
  Paper,
  CardHeader,
  Typography,
  CardContent,
  Button,
  IconButton,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogContentText,
  DialogActions,
  Divider,
  Box,
  Stack,
} from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import axios from "axios";
import useAxiosAuth from "../../../../hooks/useAxiosAuth";

//project components
import WorkExperienceForm from "../work-experience/WorkExperienceForm";
import config from "../../../../config";
import { useSelector } from "react-redux";
import {
  convertDateToLocal,
  convertDateToLocalReverse,
} from "../../../../utils/date-operations";
import NoDataFound from "../../../../components/NoDataFound";

const WorkExperience = (props) => {
  //Constants
  const axiosAuth = useAxiosAuth();
  const { workExperiences, onSave, candidateId } = props;
  const { userId, profileId, userName, role, displayRole } = useSelector(
    (state) => state.userReducer
  );

  //States
  const [openAdd, setOpenAdd] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [selectedWorkExperience, setSelectedWorkExperience] = useState({
    id: 0,
    candidateId: candidateId,
    companyName: "",
    position: "",
    salary: 0,
    experience: 0,
    fromDate: convertDateToLocalReverse(new Date()),
    toDate: convertDateToLocalReverse(new Date()),
    tillToday: false,
  });

  //Methods
  const handleAdd = () => {
    setSelectedWorkExperience({
      id: 0,
      candidateId: candidateId,
      companyName: "",
      position: "",
      salary: 0,
      experience: 0,
      fromDate: convertDateToLocalReverse(new Date()),
      toDate: convertDateToLocalReverse(new Date()),
      tillToday: false,
    });
    setOpenAdd(true);
  };

  const handleDelete = () => {
    axiosAuth
      .delete("/api/CandidateWorkExpriences/" + selectedWorkExperience.id)
      .then((response) => {
        onSave();
        setOpenDelete(false);
      })
      .catch((error) => {
        console.log(error);
        setOpenDelete(false);
      });
  };

  const handleSave = () => {
    onSave();
    setOpenAdd(false);
  };

  const handleCancel = () => {
    setOpenAdd(false);
  };

  const handleCancelDelete = () => {
    setOpenDelete(false);
  };

  return (
    <Card elevation={3}>
      <Grid
        sx={{
          background: "linear-gradient(to right,#4a7dcf 0%, #2a569f 100%)",
          paddingX: 2,
          paddingY: 0.5,
        }}
      >
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Grid item>
            <Typography
              variant="h6"
              sx={{
                color: "#ffffff",
              }}
            >
              Work Experience
            </Typography>
          </Grid>
          {role !== 4 && (
            <Grid item>
              <IconButton onClick={handleAdd}>
                <AddIcon sx={{ color: "#ffffff" }} />
              </IconButton>
            </Grid>
          )}
        </Grid>
      </Grid>
      <Grid item>
        <Box
          sx={{
            display: { xs: "flex", md: "none" },
            flexDirection: "column",
          }}
        >
          {workExperiences && workExperiences?.length > 0 ? (
            workExperiences.map((workExperience, index) => {
              return (
                <Card
                  key={index}
                  variant="outlined"
                  sx={{
                    margin: 1,
                    paddingX: 1,
                    paddingY: 2,
                    // display: "flex",
                    // justifyContent: "space-between",
                    backgroundColor: "#F5F5F5",
                  }}
                >
                  <Stack spacing={1}>
                    <Typography>
                      <b>Company Name:</b> {workExperience.companyName}
                    </Typography>
                    <Typography>
                      <b>Position:</b> {workExperience.position}
                    </Typography>
                    <Typography>
                      <b>Duration:</b>{" "}
                      {convertDateToLocal(workExperience.fromDate)} -
                      {workExperience.tillToday
                        ? "Till Today"
                        : convertDateToLocal(workExperience.toDate)}
                    </Typography>
                  </Stack>
                  {role !== 4 && (
                    <>
                      <Divider sx={{ my: 1 }} />
                      <Stack
                        // alignItems="center"
                        // justifyContent="center"
                        // spacing={2}
                        direction="row"
                      >
                        <IconButton
                          variant="outlined"
                          color="primary"
                          size="small"
                          onClick={() => {
                            setSelectedWorkExperience(workExperience);
                            setOpenAdd(true);
                          }}
                        >
                          <EditIcon fontSize="inherit" />
                        </IconButton>
                        <IconButton
                          color="error"
                          size="small"
                          onClick={() => {
                            setSelectedWorkExperience(workExperience);
                            setOpenDelete(true);
                          }}
                        >
                          <DeleteIcon fontSize="inherit" />
                        </IconButton>
                        {/* <Typography>{index + 1}</Typography> */}
                      </Stack>
                    </>
                  )}
                </Card>
              );
            })
          ) : (
            <Box sx={{ p: 3, display: "flex", justifyContent: "center" }}>
              <Typography variant="body1" color="text.secondary">
                No work experience data available
              </Typography>
            </Box>
            // <NoDataFound />
          )}
        </Box>
        <Box
          sx={{
            display: { xs: "none", md: "flex" },
            flexDirection: "column",
          }}
        >
          {workExperiences && workExperiences?.length > 0 ? (
            <TableContainer>
              <Table aria-label="simple table" size="small">
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ width: 40 }}>#</TableCell>
                    <TableCell align="left">Company Name</TableCell>
                    <TableCell align="left" sx={{ width: 120 }}>
                      Position
                    </TableCell>
                    <TableCell align="left" sx={{ width: 120 }}>
                      Experience
                    </TableCell>
                    <TableCell align="left" sx={{ width: 120 }}>
                      Salary / Month
                    </TableCell>
                    <TableCell align="left" sx={{ width: 180 }}>
                      Duration
                    </TableCell>
                    <TableCell align="right" sx={{ width: 90 }}></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {workExperiences.map((row, index) => (
                    <TableRow key={row.id}>
                      <TableCell component="th" scope="row">
                        {index + 1}
                      </TableCell>
                      <TableCell align="left">{row.companyName}</TableCell>
                      <TableCell align="left">{row.position}</TableCell>
                      <TableCell align="left">{row.experience}</TableCell>
                      <TableCell align="left">{row.salary}</TableCell>
                      <TableCell align="left">
                        {convertDateToLocal(row.fromDate)} -{" "}
                        {row.isCurrent || !row.toDate
                          ? "Till Today"
                          : convertDateToLocal(row.toDate)}
                      </TableCell>
                      <TableCell align="right">
                        {role !== 4 && (
                          <>
                            <IconButton
                              variant="outlined"
                              color="primary"
                              size="small"
                              onClick={() => {
                                setSelectedWorkExperience(row);
                                setOpenAdd(true);
                              }}
                            >
                              <EditIcon fontSize="inherit" />
                            </IconButton>
                            <IconButton
                              color="error"
                              size="small"
                              onClick={() => {
                                setSelectedWorkExperience(row);
                                setOpenDelete(true);
                              }}
                            >
                              <DeleteIcon fontSize="inherit" />
                            </IconButton>
                          </>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Box sx={{ p: 3, display: "flex", justifyContent: "center" }}>
              <Typography variant="body1" color="text.secondary">
                No work experience data available
              </Typography>
            </Box>
            // <NoDataFound />
          )}
        </Box>
      </Grid>
      <Dialog open={openAdd} onClose={handleCancel} fullWidth>
        <DialogContent>
          <WorkExperienceForm
            onSave={handleSave}
            onCancel={handleCancel}
            selectedWorkExperience={selectedWorkExperience}
          />
        </DialogContent>
      </Dialog>
      <Dialog open={openDelete} onClose={handleCancelDelete} fullWidth>
        <DialogTitle>Delete Work Experience</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete the work experience of{" "}
            <span style={{ color: "#E90000" }}>
              {selectedWorkExperience?.companyName}
            </span>
            ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDelete} variant="contained">
            Yes
          </Button>
          <Button onClick={handleCancelDelete} variant="outlined">
            No
          </Button>
        </DialogActions>
      </Dialog>
    </Card>
  );
};

export default WorkExperience;
